import React, { useEffect, useState } from "react";
import SearchBar from "../SearchBar/SearchBar";

const NoDataTable = ({ searchBarPlaceholder, searchBarClassName = "" }) => {
  const [rowCount, setRowCount] = useState(0);

  useEffect(() => {
    const rowHeight = 60;
    const headerHeight = 62;
    const screenHeight = window.innerHeight;
    const availableHeight = screenHeight - headerHeight;
    const rows = Math.floor(availableHeight / rowHeight);
    setRowCount(rows);

    const handleResize = () => {
      const newRows = Math.floor(
        (window.innerHeight - headerHeight) / rowHeight,
      );
      setRowCount(newRows);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex flex-col h-[calc(100dvh-120px)] p-4 relative">
      {/* Faded placeholder table */}
      <div className="opacity-20 relative">
        <div className="pb-5">
          <SearchBar disabled placeholder={searchBarPlaceholder} className={searchBarClassName} />
        </div>
        {/* table no data found UI */}
        <div className="flex flex-col gap-[18px] flex-1">
          {[...Array(rowCount)].map((_, index) => (
            <div key={index} className="flex gap-2 items-center">
              <div className="bg-gray-200 dark:bg-gray-800 h-4 w-4 rounded-md" />
              <div className="bg-gray-200 dark:bg-gray-800 h-8 w-8 rounded-full" />
              <div className="flex gap-5 w-full">
                <div className="bg-gray-200 dark:bg-gray-800 h-6 min-w-28 rounded-2xl" />
                <div className="bg-gray-200 dark:bg-gray-800 h-6 min-w-28 rounded-2xl" />
                <div className="bg-gray-200 dark:bg-gray-800 h-6 min-w-11 rounded-2xl" />
                <div className="bg-gray-200 dark:bg-gray-800 h-6 w-full rounded-2xl" />
                <div className="bg-gray-200 dark:bg-gray-800 h-6 min-w-28 rounded-2xl" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoDataTable;
